import { CallbackType, FRCallback, SelectIdPCallback } from '@forgerock/javascript-sdk';

let count = 0;

interface CreateInputCallbackOptions {
  required?: boolean;
  policies?: unknown[];
}

export const createInputCallback = (
  type: InputCallbackType,
  prompt: string,
  name = '',
  value = '',
  { required = true, policies = [] }: CreateInputCallbackOptions = {},
) =>
  ({
    type: type,
    output: [
      { name: 'name', value: name !== '' ? name : prompt },
      { name: 'prompt', value: prompt },
      { name: 'required', value: required },
      {
        name: 'policies',
        value: {
          policies: policies,
        },
      },
      { name: 'failedPolicies', value: [] },
      { name: 'validateOnly', value: false },
      { name: 'value', value },
    ],
    input: [
      { name: `IDToken${count++}`, value: '' },
      { name: 'IDToken1validateOnly', value: '' },
    ],
    _id: count,
  }) as unknown as FRCallback;

export const createMessageCallback = (message: string, messageType = '0') =>
  ({
    type: CallbackType.TextOutputCallback,
    output: [
      {
        name: 'message',
        value: message,
      },
      {
        name: 'messageType',
        value: messageType,
      },
    ],
    _id: count++,
  }) as unknown as FRCallback;

export const createPasswordCallback = (prompt: string, isPasswordCreation = false) =>
  ({
    type: isPasswordCreation ? CallbackType.ValidatedCreatePasswordCallback : CallbackType.PasswordCallback,
    output: [
      {
        name: 'prompt',
        value: prompt,
      },
    ],
    input: [
      {
        name: `IDToken${count++}`,
        value: '',
      },
    ],
    _id: count,
  }) as unknown as FRCallback;

export const createIdpCallback = () =>
  ({
    type: CallbackType.SelectIdPCallback,
    output: [
      {
        name: 'providers',
        value: [
          {
            provider: 'Paypal_Darty',
            uiConfig: {
              buttonCustomStyle: 'background-color: #fff;border-color: #2997D8; color: #2997D8;',
              buttonImage: 'images/paypal.svg',
              buttonClass: 'fa-brands fa-paypal',
              buttonCustomStyleHover: 'background-color: #eee;border-color: #253B80; color: white;',
              buttonDisplayName: 'PayPal',
              iconClass: 'fa-paypal',
              iconFontColor: 'white',
              iconBackground: '#253B80',
            },
          },
          {
            provider: 'localAuthentication',
          },
        ],
      },
      {
        name: 'value',
        value: '',
      },
    ],
    input: [
      {
        name: 'IDToken1',
        value: '',
      },
    ],
    _id: count,
  }) as unknown as SelectIdPCallback;

export enum InputCallbackType {
  TEXT = CallbackType.StringAttributeInputCallback,
  BOOLEAN = CallbackType.BooleanAttributeInputCallback,
}

export const createRegexPolicy = (regexp: string | RegExp) => {
  const stringRegex = typeof regexp === 'object' ? regexp.toString().replaceAll('/', '') : regexp;
  return {
    policyRequirements: ['MATCH_REGEXP'],
    policyId: 'regexpMatches',
    params: {
      regexp: stringRegex,
    },
  };
};

export const createConfirmationCallback = (options: string[], prompt = '', messageType = '0', optionType = '-1', defaultOption = '1') =>
  ({
    type: CallbackType.ConfirmationCallback,
    output: [
      {
        name: 'prompt',
        value: prompt,
      },
      {
        name: 'messageType',
        value: messageType,
      },
      {
        name: 'options',
        value: options,
      },
      {
        name: 'optionType',
        value: optionType,
      },
      {
        name: 'defaultOption',
        value: defaultOption,
      },
    ],
    input: [
      {
        name: `IDToken${count++}`,
        value: 0,
      },
    ],
    _id: count,
  }) as unknown as FRCallback;
